'use client';

import React from 'react';
import { Checkbox as HeadlessCheckbox } from '@headlessui/react';

import Icon from '../../Icon/Icon';

import styles from './Checkbox.module.css';

interface Props {
    checked?: boolean;
    name?: string;
    onChange: (value: boolean) => void;
}

const Checkbox = ({ name, checked, onChange }: Props) => (
    <HeadlessCheckbox
        checked={checked}
        onChange={onChange}
        name={name}
        className="inline-block align-middle h-[19.5px] w-[19.5px]"
    >
        {({ checked }) => (
            <span className={`${styles.Checkbox} ${(checked) ? styles.CheckboxChecked : ''}`}>
                <Icon
                    size="small"
                    icon="check"
                    className={`${styles.CheckboxIcon} ${(checked) ? styles.CheckboxIconChecked : ''}`}
                />
            </span>
        )}
    </HeadlessCheckbox>
)

export default Checkbox;
